module.exports = __webpack_public_path__ + "static/media/product-7.4c6ab223.png";